import {
    //Dialog,
    // DialogTitle,
    DialogActions,
    //DialogContent,
    MenuItem,
    FormControl,
    Grid,
    Divider,
    Radio,
    RadioGroup,
    FormControlLabel,
    TextField,
    Avatar,
    ListItemAvatar,
    Stack,
    Drawer

} from '@mui/material';

//import BadgeStatus from '../../../BadgeStatus';
import { LoadingButton } from '@mui/lab';
import HeaderModal from 'src/components/modal/HeaderModal';
import { SelectZui } from 'src/components/zui';
import { SelectItem } from 'src/@/components/ui/select';
import { Checkbox } from 'src/@/components/ui/checkbox';
import { useEffect, useState } from 'react';
import { Switch } from 'src/@/components/ui/switch';
import { Button } from "src/@/components/ui/button"
import { Input } from "src/@/components/ui/input"
import { Label } from "src/@/components/ui/label"
import {
    Popover,
    PopoverContent,
    PopoverTrigger,
} from "src/@/components/ui/popover"
import Iconify from 'src/components/Iconify';
import getActionListaUsuariosByClienteId from 'src/actions/usuarios/getActionListaUsuariosByClienteId';
import { ButtonLoading } from 'src/@/components/use/ButtonLoading';
import { useSnackbar } from 'notistack';
import v2_actionEditarLead from 'src/actions/v2/crm/v2_actionEditarLead';
import { RowInput } from 'src/components/forms/RowInput';
import { OptionsSelect } from 'src/@/components/shared';
import v2_actionDeletarLead from 'src/actions/v2/crm/v2_actionDeletarLead';

// ----------------------------------------------------------------------

export default function DrawerDeleteLead({ user, lead, onCallback, configCrm, open, onOpenChange }) {
    const [loading, setLoading] = useState(false);
    const { enqueueSnackbar } = useSnackbar();



    async function deletarLead() {

        try {

            setLoading(true);
            await v2_actionDeletarLead(lead?._id);
            setLoading(false);
            onCallback();
            enqueueSnackbar('Lead excluido com sucesso', { variant: 'success', autoHideDuration: 3000, anchorOrigin: { vertical: 'bottom', horizontal: 'left' } });
        } catch (error) {
            setLoading(false);
            console.log('error', error)
            enqueueSnackbar('Erro ao excluir lead. Tente novamente', { variant: 'error', autoHideDuration: 3000, anchorOrigin: { vertical: 'bottom', horizontal: 'left' } });
        }
    }



    return (
        <Popover open={open} onOpenChange={onOpenChange}>
            <PopoverTrigger asChild>
                <Button className="flex justify-center h-8" variant="outline">
                    <Iconify icon="ic:baseline-delete" className="text-red-500" />
                </Button>
            </PopoverTrigger>
            <PopoverContent className="w-80 z-[9999]">
                <div className="flex flex-col gap-4">
                    <p className="leading-7 [&:not(:first-child)]:mt-6">
                        Deseja realmente excluir esse negócio?
                    </p>
                    <div className='flex gap-2'>
                        <Button variant="outline" onClick={() => onOpenChange()}>Cancelar</Button>
                        <ButtonLoading
                            loading={loading}
                            onClick={() => deletarLead()}
                            className={`bg-red-500 w-full`}
                        >
                            {loading ? 'Excluindo...' : 'Excluir'}
                        </ButtonLoading>
                    </div>
                </div>
            </PopoverContent>
        </Popover>
    )

}
